export class ArrearsViewTypes {
  static readonly agedArrearsTable = 'agedArrearsTable';
  static readonly pie = 'pie';
  static readonly bar = 'bar';
  static readonly doughnut = 'doughnut';
  static readonly transactionTable = 'transactionTable';

  static readonly all = [
    ArrearsViewTypes.agedArrearsTable,
    ArrearsViewTypes.pie,
    ArrearsViewTypes.bar,
    ArrearsViewTypes.doughnut,
    ArrearsViewTypes.transactionTable
  ];

}

export type ArrearsViewType =
  | 'agedArrearsTable'
  | 'pie'
  | 'bar'
  | 'doughnut'
  | 'transactionTable';
